import { styled } from "@mui/material/styles";
import { SvgIconProps } from "@mui/material/SvgIcon";
import SwapCallsIcon from "@mui/icons-material/SwapCalls";
import React, { FunctionComponent } from "react";

const PREFIX = "SwapCallsHorizIcon";

const classes = {
	root: `${PREFIX}root`,
};

const StyledSwapCallsIcon = styled(SwapCallsIcon)(({
	theme,
}) => ({
	[`&.${classes.root}`]: {
		transform: "rotate(90deg)",
	},
}));

export const SwapCallsHorizIcon: FunctionComponent<SvgIconProps> = (props) => {
	const { className, ...otherProps } = props;


	return (
		<StyledSwapCallsIcon
			className={`${classes.root} ${className || ""}`}
			{...otherProps}
		/>
	);
};

export default SwapCallsHorizIcon;
